import {User} from '../../../domain/core/model/user';
import {Account} from '../../../domain/core/model/account';
import {ApplicationName} from '../../../domain/core/model/aplication-name.enum';
import {Application} from '../../../domain/core/model/application';

export class UserContext {
  accountId: string | null;
  user: User;
  locale: string;
  isAssistanceEnabled = false;

  constructor(accountId: string | null, user: User, local: string) {
    this.accountId = accountId;
    this.user = user;
    this.locale = local;
    const account = user.accounts.find(a => a.accountId === accountId);

    if (account != null) {
      this.isAssistanceEnabled = account.applications.filter(application => this.hasAccessToAsisstance(application)).length > 0;
    }
  }

  getCurrentAccount(): Account | undefined {
    return this.user.accounts.find(a => a.accountId === this.accountId);
  }

  private hasAccessToAsisstance(application: Application): boolean {
    return application.targetApp === ApplicationName.ASSISTANCE
           && application.hasAccess;
  }
}
